import { LalSegmentList as LalSegmentListUI } from '@openx/components-segment/lib/LalSegmentsList/LalSegmentList.tsx';
import type { ListLalSegment } from '@openx/types/segments.ts';
import { applySelectionChange } from '@openx/utils/lib/applySelectionChange.ts';
import isEqual from 'lodash/isEqual';
import { useCallback } from 'react';
import { useLalSegmentsList } from '../hooks/useLalSegmentsList.tsx';

export type LalSegmentsListProps = {
  selectedSegments: ListLalSegment[];
  setSelectedSegments: (segments: ListLalSegment[]) => void;
};

export const LalSegmentsList = ({ selectedSegments, setSelectedSegments }: LalSegmentsListProps) => {
  const { lalSegments, loading, error, criteria, handleCriteriaChange } = useLalSegmentsList();

  const handleSelectionChange = useCallback(
    (selectedItems, operation) => {
      const selectedSegmentsNext = applySelectionChange({
        changeItems: selectedItems,
        itemsComparer: isEqual,
        operation,
        previouslySelectedItems: selectedSegments,
      });
      setSelectedSegments(selectedSegmentsNext);
    },
    [selectedSegments, setSelectedSegments]
  );

  if (error) {
    throw new Error('Lookalike Segments Error');
  }

  return (
    <LalSegmentListUI
      criteria={criteria}
      handleCriteriaChange={handleCriteriaChange}
      handleFiltersChange={handleCriteriaChange}
      handleSelectionChange={handleSelectionChange}
      loading={loading}
      segments={loading ? [] : lalSegments}
      selectedSegments={selectedSegments}
    />
  );
};
